export default "__VITE_ASSET__BTBKpt$5__"